import styles from './styles.module.scss';

const ScoringLegend = () => {
  const scoringGrid = Array.from({ length: 10 }, (_, i) => (i + 1) * 10);

  return (
    <div className={styles.scoringLegend}>
      <span className={styles.scoringLegendLabel}>BBCH (%)</span>
      {scoringGrid.map((column) => {
        return (
          <div className={styles.scoringLegendCell} key={column.toString()}>
            <span>{column}</span>
          </div>
        );
      })}
    </div>
  );
};

export default ScoringLegend;
